import styled from "styled-components";

export const Container = styled.main`
    display: inline-block;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-radius: 30px;
`;

export const Button = styled.button<{ isActive: boolean }>`
    border-radius: 30px;
    padding: 5px 10px;

    background-color: ${(props) =>
        (props.isActive ? props.theme.colors.white : props.theme.colors.gray.gray_50)};
    color: ${(props) =>
        (props.isActive ? props.theme.colors.gray.gray_800 : props.theme.colors.gray.gray_100)};
    box-shadow: ${(props) =>
        props.isActive ? `0px 1px 4px 0px ${props.theme.colors.gray.gray_100}` : 'none'};

    &:hover{
        color:${(props) => props.theme.colors.gray.gray_800};
    }
`;